<h3>{{data.title}}</h3>
<textarea [(ngModel)]="data.comment"></textarea>
<button (click)="updateComment()">Update</button>